import { formatCurrency } from "../../lib/utils";

const dt = (iso) => (iso ? new Date(iso).toLocaleString("pt-PT", { dateStyle: "short", timeStyle: "short" }) : "—");

// Lista de transações TPA para conferir linha a linha com o extrato bancário
export const TPATransactionsTable = ({ transactions }) => (
  <div className="overflow-x-auto rounded-lg border" data-testid="tpa-transactions-table">
    <table className="w-full text-sm">
      <thead className="bg-muted/50 text-xs uppercase text-muted-foreground">
        <tr>
          <th className="text-left p-2">Data / hora</th>
          <th className="text-left p-2">TPA</th>
          <th className="text-left p-2">Pedido</th>
          <th className="text-left p-2">Fatura</th>
          <th className="text-left p-2">Operador</th>
          <th className="text-right p-2">Valor</th>
        </tr>
      </thead>
      <tbody>
        {!transactions.length && <tr><td colSpan={6} className="p-4 text-center text-muted-foreground">Sem vendas com TPA no período</td></tr>}
        {transactions.map((t, i) => (
          <tr key={i} className={`border-t ${t.cancelled ? "opacity-60" : ""}`} data-testid={`tpa-tx-${i}`}>
            <td className="p-2 font-mono text-xs">{dt(t.time)}</td>
            <td className="p-2 font-medium">{t.tpa_name}{t.cancelled && <span className="ml-2 rounded bg-red-600 px-1.5 py-0.5 text-[10px] font-bold text-white" data-testid={`tpa-tx-cancelled-${i}`}>ANULADA · estorno</span>}</td>
            <td className="p-2">{t.order_number ? `#${t.order_number}` : "—"}</td>
            <td className="p-2 font-mono text-xs">{t.invoice_number || "—"}</td>
            <td className="p-2 text-xs text-muted-foreground">{t.operator || "—"}</td>
            <td className={`p-2 text-right font-mono font-semibold ${t.cancelled ? "line-through text-muted-foreground" : ""}`}>{formatCurrency(t.amount)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
